
import './App.css';
import Home from "./Pages/Home/home.jsx"
import Navbar from "./Section/Home/Header/navbar.jsx"
import Privacy from './Section/Home/privacy/Privacy.jsx';
import Fnb from "./Pages/Fnb/Fnb.jsx"
import Investment from './Pages/Investment/Investment.jsx';
import Office from './Pages/Office/Office.jsx'

import Footer from "./Section/Home/Footerup/footerup.jsx"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";


function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy-policy" element={<Privacy />} />
        <Route path='/FnB' element={<Fnb/>}/>
        <Route path='/Investment' element={<Investment/>}/>
        <Route path='/Office' element={<Office/>}/>
 
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;